<template lang="pug">
div(v-if="car")
  v-card.my-8.mx-0 
    v-card-title.car-header(
      center,
      v-bind:class="{ orange: car.Recommended == 0 }"
    ) {{ car.Name }}
    v-img.white--text.align-end(style="cursor: pointer;"
      :src="car.Image ? (car.Image.startsWith('https://') ? car.Image : 'https://powersell.appstack.me/' + car.Image) : '/icons/add_photo.svg'",
      height="30vh",
      @click="openListings"
    )
      v-card-title.headline {{ price }}
    v-chip.ma-2(v-if="car.Unsuitable", label, color="cyan", text-color="white") 
      v-icon(left) mdi-alert-octagon
      span Check with your dealer if this car suits your driving needs
    v-card-actions(v-if="!contact")
      v-row
        v-col(cols=12)
          v-dialog(v-model="dialog", max-width="640")
            template(v-slot:activator="{ on }")
              v-btn(v-on="on", color="primary", block) Enquire Now
            ContactForm(
              :carList="carList",
              :selectedIndex="selectedIndex",
              :currentCar="currentCar",
              :trips="trips",
              :bubble="bubble",
              @close="dialog = false"
            )
    div.text-h5.font-weight-bold.ml-2.pt-2.center Estimated annual savings*
    v-row(align="center", justify="center")
      v-col(cols=6)
          div.text-h6.font-weight-light.center.mt-4 Running costs
          div.text-h4.savings {{ runningCostsSavings }}
      v-col(cols=6)
          div.text-h6.font-weight-light.center.mt-4 Emissions
          div.text-h4.savings {{ co2Savings }} kg
    v-row(align="center" justify="center")
      div.font-weight-light 
        | *Based on your 
        a(@click="triggerSettings") settings 
        | and 
        a(@click="showTrips") trips
    v-row.mx-2(justify="center")
      v-col
        v-btn.pa-4(block elevation=1 @click="showTripPlanner") View trips in trip planner
    v-row.mx-2(align="baseline")
      v-col(cols=12)
        v-select(
          :items="carList",
          v-model="selectCar",
          label="CHOOSE ANOTHER EV",
          item-text="ListName",
          solo,
          return-object,
          @change="updateSelected"
          attach
        )
      v-col(cols=12 v-if="mobile")
        ActionBar(:recommenderMode="true")

  v-card
    v-fade-transition(mode="out-in")
      v-card-title(:key="car.Name") Savings breakdown for {{ car.Name }}
    v-tabs(fixed-tabs)
      v-tab Weekly Driving
      v-tab(:disabled="trips.length == 0") Trips
      v-tab(:disabled="trips.length == 0") Both
      v-tab-item
        v-simple-table.mx-4(
          :items="savingDetailsHome",
          :headers="headers",
          hide-default-header,
          hide-default-footer,
          dense
        )
          template(v-slot:default)
            thead
              tr
                th
                th
                th
            tbody
              tr(v-for="item in savingDetailsHome", :key="item.name")
                td {{ item.name }}
                td {{ item.label }}
                td {{ item.savings }}
      v-tab-item
        v-simple-table.mx-4(
          :items="savingDetailsTrips",
          :headers="headers",
          hide-default-header,
          hide-default-footer,
          dense
        )
          template(v-slot:default)
            thead
              tr
                th
                th
                th
            tbody
              tr(v-for="item in savingDetailsTrips", :key="item.name")
                td {{ item.name }}
                td {{ item.label }}
                td {{ item.savings }}
      v-tab-item
        v-simple-table.mx-4(
          :items="savingDetailsBoth",
          :headers="headers",
          hide-default-header,
          hide-default-footer,
          dense
        )
          template(v-slot:default)
            thead
              tr
                th
                th
                th
            tbody
              tr(v-for="item in savingDetailsBoth", :key="item.name")
                td {{ item.name }}
                td {{ item.label }}
                td {{ item.savings }}
    v-card-text.disclaimer *This estimate uses map data, like hills, road layout, and driving speeds with cost and efficiency estimates that you can see in the settings below.
    v-card-actions
      v-row(justify="center")
        v-col(cols=12, sm=4)
          v-btn(small, block, @click="triggerSettings") Adjust Settings*
</template>

<script>
import ContactForm from "./ContactForm";
import CarSavings from "../mixins/CarSavings";
import ActionBar from "../components/ActionBar.vue";

import { headerBus } from "../main";

export default {
  props: ["carList", "selectedIndex", "trips", "contact", "currentCar"],
  mixins: [CarSavings],
  data() {
    return {
      name: "CarDetails",
      dialog: false,
      tab: 0,
      co2Data: [
        { Name: "Kauri", PerTree: 1031 },
        { Name: "Totara", PerTree: 593 },
        { Name: "Kahikatea", PerTree: 102 },
        { Name: "Puriri", PerTree: 1779 },
        { Name: "Red Beech", PerTree: 127 },
        { Name: "Black Beech", PerTree: 65 },
        { Name: "Pohutukawa", PerTree: 385 },
        { Name: "Rata", PerTree: 147 },
      ],
      treeIndex: Math.floor(Math.random() * 8),
      selected: false,
      headers: [
        { text: "", align: "start", value: "name" },
        { text: "", align: "center", value: "label" },
        { text: "", align: "end", value: "savings" },
      ],
    };
  },
  computed: {
    car() {
      return this.currentCar ? this.currentCar : this.carList[this.selectedIndex];
    },
    selectCar: {
      get: function () {
        if (this.selected) {
          return this.carList[this.selectedIndex];
        }
        return null;
      },
      set: function (value) {
        console.log(value);
      },
    },
    price() {
      if (this.car.ListingPrice) {
        return "$" + this.car.ListingPrice;
      }
      return (
        "$" + this.formatPrice(this.car.Price) + (this.settings.excludeORC ? "+ORC" : "")
      );
    },
    runningCostDetails() {
      return (
        "Over 5 years you could pay $" +
        this.formatPrice(this.car.PetrolEquivilent * 5) +
        " to run a petrol car, or $" +
        this.formatPrice(this.car.RunningCosts * 5) +
        " to run this car"
      );
    },
    co2SavingsDetails() {
      let tree = this.co2Data[this.treeIndex];
      let amount = Math.ceil(this.car.CO2Savings / tree.PerTree);
      return (
        this.car.CO2Savings.toLocaleString("en") +
        "kgs is roughly the same as spending " +
        Math.ceil(this.car.CO2Savings / 250).toLocaleString("en") +
        " hours on a plane, or planting about " +
        amount +
        " " +
        tree.Name +
        " tree" +
        (amount > 1 ? "s" : "") +
        " per year*"
      );
    },

    runningCostsSavings() {
      let savings = Math.max(0, this.totalSavings(this.bubble.savingsMode));

      return "$" + this.formatPrice(savings);
    },
    runningCosts() {
      return "$" + this.formatPrice(this.car.RunningCosts);
    },
    co2Savings() {
      return this.car.CO2Savings.toLocaleString("en");
    },
    savingDetailsHome() {
      return this.calculateDetails("home");
    },
    savingDetailsTrips() {
      return this.calculateDetails("trips");
    },
    savingDetailsBoth() {
      return this.calculateDetails("both");
    },
  },
  methods: {
    showTrips() {
      this.$emit("showTrips");
    },
    calculateDetails(mode) {
      let ret = [
        {
          name: "Estimated petrol costs",
          savings: "$" + this.formatPrice(this.petrolCosts(mode)),
        },
        { label: "Minus" },
        {
          name: "Cost of home-charging",
          savings: "$" + this.formatPrice(this.homeCharging(mode)),
        },
      ];

      if (this.car.Hybrid == true) {
        ret.push({
          name: "Fuel Cost",
          savings: "$" + this.formatPrice(this.hybridGetFuelCost(mode)),
        });
      } else {
        ret.push({
          name: "Cost of public-charging",
          savings: "$" + this.formatPrice(this.publicCharging(mode)),
        });
      }

      ret.push({ label: "Plus" });
      ret.push(
        {
          name: "Maintenance savings",
          savings: "$" + this.formatPrice(this.maintenanceSavings),
        },
        { label: "Equals" },
        {
          name: "Total savings",
          savings: "$" + this.formatPrice(this.totalSavings(mode)),
        },
        {
          name: "Based on driving",
          savings: this.formatPrice(this.drivingkms(mode)) + " kms",
        }
      );

      return ret;
    },
    updateSelected(selected) {
      this.$emit("change", selected);
      this.selected = true;
    },
    triggerSettings() {
      headerBus.$emit("showSettings");
    },
    openListings() {
      console.log(this.car);
      let link = this.car.ListingLink
        ? this.car.ListingLink.startsWith("http")
          ? this.car.ListingLink
          : this.$dealer.default_settings.baseURL + this.car.ListingLink
        : this.$dealer.default_settings.listingLink;
      window.open(link, "_blank");
    },
    showTripPlanner() {
      this.$router.push("/planner");
    },
  },
  components: {
    ContactForm,
    ActionBar,
  },
};
</script>

<style scoped>
.car-header {
  text-align: center;
  display: block;
  background: #eee;
  padding: 10px;
}
.short-row {
  height: 20px;
}
.unsuitable {
  color: red;
}
.savings {
  color: green;
  text-align: center;
  font-size: 32px;
  font-weight: bold !important;
}
.small {
  font-size: 0.8em;
  text-align: center;
  line-height: 1.1;
}
.details {
  font-size: 0.75em;
  text-align: center;
  line-height: 1.1;
  margin-top: -10px;
  padding: 5px;
}
.recommended {
  font-weight: bold;
}
.big_plus {
  text-align: center;
  font-weight: bold;
  font-size: 2em;
  margin-top: -30px;
}
.disclaimer {
  font-style: italic;
  text-align: center;
}

.center {
  text-align: center;
}

.mx-20 {
  margin-left: 80px;
  margin-right: 80px;
}
.and {
  margin-bottom: 40px;
  position: relative;
  top: -10px;
}

.savings-icon {
  filter: invert(21%) sepia(89%) saturate(3064%) hue-rotate(96deg) brightness(95%)
    contrast(104%);
  margin-right: 5px;
}

.v-data-table__mobile-row__cell:first-child {
  font-weight: 600 !important;
}

.v-data-table .v-data-table__mobile-row {
  min-height: 24px;
}
</style>
